import { useTheme } from '@mui/material';
import AssetBox, { CoverImageAssetBox } from './AssetBox';
import DSBox from '../../../../../design-system/DSBox';

export type AssetsTabProps = {
  logoUrl: string;
  coverUrl: string;
  thumbnailBackgroundUrl?: string;
  logoTypeURL?: string;
};

const AssetsTab = ({
  logoUrl,
  coverUrl,
  thumbnailBackgroundUrl,
  logoTypeURL,
}: AssetsTabProps) => {
  const { spacing } = useTheme();

  return (
    <DSBox
      sx={{
        display: 'flex',
        gap: spacing(4),
        width: '100%',
        flexDirection: 'row',
      }}
    >
      <CoverImageAssetBox
        label="Cover"
        imageUrl={coverUrl}
        alt="Collection Cover"
      />
      <AssetBox label="Logo" imageUrl={logoUrl} alt="Collection Logo" />
      {thumbnailBackgroundUrl && (
        <AssetBox
          label="Thumbnail Background"
          imageUrl={thumbnailBackgroundUrl}
          alt="Collection Thumbnail Background"
        />
      )}
      {logoTypeURL && (
        <AssetBox
          label="Logotype"
          imageUrl={logoTypeURL}
          alt="Collection Logotype"
        />
      )}
    </DSBox>
  );
};

export default AssetsTab;
